import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuotesPageRoutingModule } from './quotes-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { QuotesComponent } from './quotes.component';
import { NgProgressModule } from 'ngx-progressbar';
import { SharedModule } from '../shared/shared.module';
import { MatSortModule } from '@angular/material/sort';
import { OpenQuotesComponent } from './open-quotes/open-quotes.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QuotesItemDetailComponent } from './quotes-item-detail/quotes-item-detail.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { QuoteService } from '../services/quote.service';
import { ExpiredQuotesComponent } from './expired-quotes/expired-quotes.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuoteFilterPipe } from '../shared/pipes/quotefilter.pipe';
import { PriceListComponent } from './price-list/price-list.component';
import { PriceListDetailComponent } from './price-list/price-list-detail/price-list-detail.component';
import { PriceListSummaryComponent } from './price-list/price-list-detail/price-list-summary/price-list-summary.component';
import { PriceListCheckoutComponent } from './price-list/price-list-detail/price-list-summary/price-list-checkout/price-list-checkout.component';
import { QuoteGuard } from './price-list/quote.guard';
import { ChildHeaderModule } from '../child-header/child-header.module';
import {CanActivatePriceList} from './price-list.guard';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';
import { MatTableModule } from '@angular/material/table';



@NgModule({
    imports: [
        BrowserModule,
        CommonModule,
        QuotesPageRoutingModule,
        NgProgressModule,
        SharedModule,
        NgbModule,
        NgxPaginationModule,
        FormsModule,
        MatSortModule,
        ChildHeaderModule,
        MatTableModule,
        BreadcrumbModule
    ],
    declarations: [
        QuotesComponent,
        OpenQuotesComponent,
        QuotesItemDetailComponent,
        ExpiredQuotesComponent,
        PriceListDetailComponent,
        PriceListComponent,
        PriceListSummaryComponent,
        PriceListCheckoutComponent,
        QuoteFilterPipe
    ],
    providers: [QuoteService, QuoteGuard, CanActivatePriceList]

})

export class QuotesModule { }
